import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { InputAdornment, Slider } from '@material-ui/core';
import { Inputs } from '../../../../Components';
import './SliderPrimaryUnits.scss';

export const ROIFilter = ({
  translationPath,
  parentTranslationPath,
  setSelected,
  selected,
  RangeSliderFilter,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const searchTimer = useRef(null);

  const handleSliderChange = (event, newValue) => {
    const [minValue, maxValue] = newValue;
    setSelected({
      id: 'ROI',
      value: { from: minValue, to: maxValue },
    });
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
    }
    searchTimer.current = setTimeout(() => {
      RangeSliderFilter('sale_roi', {
        from: minValue,
        to: maxValue,
      });
    }, 1000);
  };

  const handleInputChange = (value, type) => {
    if (type === 'from') {
      setSelected({
        id: 'ROI',
        value: { from: value },
      });
      if (searchTimer.current) {
        clearTimeout(searchTimer.current);
      }
      searchTimer.current = setTimeout(() => {
        RangeSliderFilter('sale_roi', {
          from: value,
          to: selected?.ROI?.to,
        });
      }, 1000);
    } else {
      setSelected({
        id: 'ROI',
        value: { from: selected?.ROI?.from, to: value },
      });
      if (searchTimer.current) {
        clearTimeout(searchTimer.current);
      }
      searchTimer.current = setTimeout(() => {
        RangeSliderFilter('sale_roi', {
          from: selected?.ROI?.from,
          to: value,
        });
      }, 1000);
    }
  };
  return (
    <div className='filter-slider-container'>
      <fieldset className='styled-fieldset'>
        <legend className='styled-legend'>
          {t(`${translationPath}ROI`)}
        </legend>
        <div className='slider-wrapper'>
          <Slider
            value={[
              Number(selected?.ROI?.from) || 0,
              Number(selected?.ROI?.to) || 0,
            ]}
            onChange={handleSliderChange}
            min={0}
            max={5000}
            valueLabelDisplay='auto'
          />
        </div>
        <div className='inputs-container'>
          <Inputs
            idRef='ROIFromRef'
            type='number'
            labelValue={t(`${translationPath}Min`)}
            value={selected?.ROI?.from || ''}
            onInputChanged={(event) => {
              const { value } = event.target;
              handleInputChange(value, 'from');
            }}
            endAdornment={<InputAdornment position='start'>%</InputAdornment>}
            min={0}
          />
          <span className='range-separator'>-</span>
          <Inputs
            idRef='ROIToRef'
            type='number'
            labelValue={t(`${translationPath}Max`)}
            value={selected?.ROI?.to || ''}
            onInputChanged={(event) => {
              const { value } = event.target;
              handleInputChange(value, 'to');
            }}
            endAdornment={<InputAdornment position='start'>%</InputAdornment>}
            min={0}
          />
        </div>
      </fieldset>
    </div>
  );
};
